import { useTranslation } from 'react-i18next';
import team from '../../../../images/bacgroundThree.png';
import man from '../../../../images/man.png';

const Bussines = () => {
  const { i18n, t } = useTranslation();

  return (
    <section className="bussines content-fix-index" id='team'>
      <div className="bussines__title">
        {i18n.language === 'en' ? (
          <><span>{t('bussinessTitle', { returnObjects: true })[0]}</span>{t('bussinessTitle', { returnObjects: true })[1]}</>
        ) : (
          <>{t('bussinessTitle', { returnObjects: true })[0]}<span>{t('bussinessTitle', { returnObjects: true })[1]}</span></>
        )}
      </div>

      <div className="bussines__container">
        <div className="bussines__image">
          <img alt="team" src={team}/>
        </div>

        <div className="bussines__info">
          <div>{t('bussinessText', { returnObjects: true })[0]}</div>
          <div>{t('bussinessText', { returnObjects: true })[1]}</div>
          <div>{t('bussinessText', { returnObjects: true })[2]}</div>
        </div>

        <img alt='man' src={man} className='bussines__man'/>
      </div>
    </section>
  );
};

export default Bussines;